<template>
  <path
    d="M13.12 2.06024L7.58 7.60024C7.21 7.97024 7 8.48024 7 9.01024V19.0002C7 20.1002 7.9 21.0002 9 21.0002H18C18.8 21.0002 19.52 20.5202 19.84 19.7902L23.1 12.1802C23.94 10.2002 22.49 8.00024 20.34 8.00024H14.69L15.64 3.42024C15.74 2.92024 15.59 2.41024 15.23 2.05024C14.64 1.47024 13.7 1.47024 13.12 2.06024ZM3 21.0002C4.1 21.0002 5 20.1002 5 19.0002V11.0002C5 9.90024 4.1 9.00024 3 9.00024C1.9 9.00024 1 9.90024 1 11.0002V19.0002C1 20.1002 1.9 21.0002 3 21.0002Z"
  />
</template>
